import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardSidebar } from '../components/dashboard/DashboardSidebar';
import { TendersList } from '../components/dashboard/TendersList';
import { SubscriptionCard } from '../components/dashboard/SubscriptionCard';
import { DashboardStats } from '../components/dashboard/DashboardStats';
import { SavedSearches } from '../components/dashboard/SavedSearches';
import { RecentActivity } from '../components/dashboard/RecentActivity';
import { BellIcon, SearchIcon, ListIcon } from 'lucide-react';
export function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Mock user data
  const user = {
    name: 'FATHALLAH Mehdi',
    company: 'Tunipages',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    email: 'mehdi.fathallah@tunipages.com',
    phone: '+33 7 53 29 34 19'
  };
  // Mock subscription data
  const subscription = {
    type: 'Essai Gratuit',
    status: 'actif',
    expiryDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    features: ['Accès à 5 pays', '3 alertes personnalisées', 'Données historiques (1 mois)', 'Support par email'],
    restrictions: ['Téléchargements limités', "Pas d'accès à l'API"]
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1971">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-1972" />}
      {/* Sidebar */}
      <DashboardSidebar open={sidebarOpen} setOpen={setSidebarOpen} data-id="element-1973" />
      {/* Main content */}
      <div className="md:pl-64" data-id="element-1974">
        {/* Header */}
        <DashboardHeader user={user} onMenuClick={() => setSidebarOpen(true)} data-id="element-1975" />
        {/* Main dashboard content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8" data-id="element-1976">
          {/* Welcome banner */}
          <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-xl p-6 mb-6 text-white shadow-lg relative overflow-hidden" data-id="element-1977">
            <div className="absolute inset-0 opacity-10" data-id="element-1978">
              <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-1979">
                <defs data-id="element-1980">
                  <pattern id="smallGrid" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-1981">
                    <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.5" data-id="element-1982" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#smallGrid)" data-id="element-1983" />
              </svg>
            </div>
            <div className="relative z-10" data-id="element-1984">
              <h1 className="text-2xl font-bold mb-2" data-id="element-1985">
                Bienvenue, {user.name.split(' ')[1]}
              </h1>
              <p className="text-blue-100 max-w-3xl" data-id="element-1986">
                Découvrez les dernières opportunités d'affaires en Afrique.
                Votre essai gratuit expire dans{' '}
                <span className="font-bold text-yellow-500" data-id="element-1987">
                  {Math.ceil((subscription.expiryDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24))}{' '}
                  jours
                </span>
                .
              </p>
              <div className="mt-4 flex flex-wrap gap-3" data-id="element-1988">
                <button className="bg-white text-blue-900 px-4 py-2 rounded-lg font-medium flex items-center hover:bg-blue-50 transition-colors" data-id="element-1989">
                  <SearchIcon size={16} className="mr-2" data-id="element-1990" />
                  Rechercher des appels d'offres
                </button>
                <button className="bg-blue-800 border border-blue-700 text-white px-4 py-2 rounded-lg font-medium flex items-center hover:bg-blue-700 transition-colors" data-id="element-1991">
                  <BellIcon size={16} className="mr-2" data-id="element-1992" />
                  Créer une alerte
                </button>
                <Link to="/premium-tenders" className="bg-blue-800 border border-blue-700 text-white px-4 py-2 rounded-lg font-medium flex items-center hover:bg-blue-700 transition-colors" data-id="element-1993">
                  <ListIcon size={16} className="mr-2" data-id="element-1994" />
                  Tous les appels d'offres
                </Link>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-40 h-40 bg-blue-700 rounded-full opacity-30 transform translate-x-1/3 -translate-y-1/3" data-id="element-1995"></div>
            <div className="absolute bottom-0 left-0 w-20 h-20 bg-yellow-500 rounded-full opacity-20 transform -translate-x-1/2 translate-y-1/2" data-id="element-1996"></div>
          </div>
          {/* Stats cards */}
          <DashboardStats data-id="element-1997" />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6" data-id="element-1998">
            {/* Subscription card */}
            <div className="lg:col-span-1" data-id="element-1999">
              <SubscriptionCard subscription={subscription} data-id="element-2000" />
            </div>
            {/* Saved searches */}
            <div className="lg:col-span-2" data-id="element-2001">
              <SavedSearches data-id="element-2002" />
            </div>
          </div>
          {/* Recent tenders */}
          <div className="mt-6" data-id="element-2003">
            <TendersList data-id="element-2004" />
          </div>
          {/* Recent activity */}
          <div className="mt-6" data-id="element-2005">
            <RecentActivity data-id="element-2006" />
          </div>
        </main>
      </div>
    </div>;
}